import ReviewsCarousel from './ReviewsCarousel';
import { useState } from 'react';

import LeadForm from './LeadForm';
import PageMeta from './PageMeta';
import { RedesignFooter, RedesignHeader, RedesignPage, SiteLink } from './RedesignShell';

const heroParagraphs = [
  'Обслуживание сайтов — это комплекс услуг, направленных на стабильную работу, безопасность и развитие веб-ресурса. Без регулярной технической поддержки сайт начинает терять позиции в поиске, появляются ошибки, снижается скорость загрузки страниц и ухудшается пользовательский опыт.',
  'Техническое обслуживание сайта включает мониторинг, обновление CMS, исправление ошибок, резервное копирование данных и доработку функционала. Такой подход позволяет обеспечить бесперебойную работу сайта и защиту персональных данных пользователей.',
  'Комплексное сопровождение сайта особенно важно для интернет-магазинов, корпоративных проектов и сервисов, где от стабильности зависит поток клиентов и продажи. В рамках услуги специалисты выполняют не только поддержку, но и развитие сайта: внедряют новые решения, улучшают дизайн, повышают конверсию и готовят ресурс к SEO-продвижению.',
  'Если сайт перестал работать корректно, медленно загружается или не приносит заявки, регулярное обслуживание и редизайн помогут быстро решить проблемы и вывести проект на новый уровень.',
];

const supportBusinessParagraphs = [
  'Обслуживание сайтов и техническая поддержка — это основа стабильной работы любого интернет-проекта. Для бизнеса сайт — это инструмент продаж, привлечения клиентов и обработки заявок. Если сайт работает с ошибками или медленно загружается, компания теряет клиентов и прибыль.',
  'Профессиональная техническая поддержка сайта позволяет избежать таких ситуаций. Специалисты контролируют работоспособность ресурса, оперативно реагируют на сбои, выполняют доработки и обеспечивают безопасность данных. Это особенно важно для интернет-магазинов, корпоративных сайтов и сервисов с высокой посещаемостью.',
  'Комплексное обслуживание сайта включает не только устранение ошибок, но и развитие проекта. В рамках поддержки выполняется обновление системы управления, внедрение новых функций, интеграция с CRM и аналитикой, а также оптимизация скорости загрузки страниц. Такой подход позволяет сайту не просто работать, а приносить стабильный результат бизнесу.',
];

const tasks = [
  {
    title: 'Поддержание работы сайта без сбоев',
    paragraphs: [
      'Обеспечивается стабильная работа сайта 24/7. Выполняется мониторинг доступности, скорости загрузки страниц и корректности всех функций.',
    ],
  },
  {
    title: 'Техническая поддержка интернет сайта',
    paragraphs: ['Решаются любые технические задачи: от исправления ошибок до сложных доработок. Работа ведется с CMS, сервером и базами данных.'],
  },
  {
    title: 'Обновление и развитие сайта',
    paragraphs: ['Регулярное обновление системы и модулей. Внедрение новых функций и интеграций.'],
  },
  {
    title: 'Улучшение дизайна и редизайн сайта',
    paragraphs: ['Проводится обновление интерфейса, повышение удобства использования и конверсии.'],
  },
  {
    title: 'Масштабирование сайта и рост функционала',
    paragraphs: ['Добавление новых разделов, расширение возможностей проекта и интеграция сервисов.'],
  },
];

const serviceItems = [
  {
    title: 'Техническое обслуживание сайта',
    paragraphs: ['Контроль работоспособности, обновления, резервное копирование и защита данных.'],
  },
  {
    title: 'Техническая поддержка веб сайта',
    paragraphs: ['Оперативное выполнение задач любой сложности. Быстрая реакция на заявки.'],
  },
  {
    title: 'Сопровождение сайта компании',
    paragraphs: ['Комплексное ведение проекта с персональным менеджером.'],
  },
  {
    title: 'Администрирование сайта',
    paragraphs: ['Управление доступами, настройка систем и контроль безопасности.'],
  },
  {
    title: 'Контентное обслуживание сайта',
    paragraphs: ['Добавление текстов, изображений, товаров и новостей.'],
  },
  {
    title: 'Обслуживание корпоративного сайта',
    paragraphs: ['Поддержка сложных систем и интеграций.'],
  },
  {
    title: 'Обслуживание сайтов на WordPress',
    paragraphs: ['Обновление, защита и оптимизация сайтов на WordPress.'],
  },
  {
    title: 'Обслуживание сайтов на Bitrix',
    paragraphs: ['Работа с 1С-Битрикс, настройка и интеграции.'],
  },
];

const redesignItems = [
  {
    title: 'Редизайн веб сайта',
    paragraphs: ['Полное обновление визуальной части сайта.'],
  },
  {
    title: 'Редизайн сайта компании',
    paragraphs: ['Адаптация дизайна под задачи бизнеса.'],
  },
  {
    title: 'Поменять дизайн сайта',
    paragraphs: ['Точечные изменения элементов интерфейса.'],
  },
  {
    title: 'Переделать дизайн сайта',
    paragraphs: ['Глубокая переработка структуры.'],
  },
  {
    title: 'Улучшение UX/UI сайта',
    paragraphs: ['Повышение удобства и логики взаимодействия.'],
  },
  {
    title: 'Усиление сайта и конверсии',
    paragraphs: ['Оптимизация пользовательских сценариев.'],
  },
];

const supportScopeItems = [
  {
    title: 'Поддержание работы сайта',
    paragraphs: ['Контроль доступности и стабильности.'],
  },
  {
    title: 'Исправление ошибок и багов',
    paragraphs: ['Быстрое устранение технических проблем.'],
  },
  {
    title: 'Обновление CMS и модулей',
    paragraphs: ['Актуализация системы управления сайтом.'],
  },
  {
    title: 'Резервное копирование сайта',
    paragraphs: ['Создание резервных копий данных.'],
  },
  {
    title: 'Мониторинг и безопасность',
    paragraphs: ['Защита от атак и вирусов.'],
  },
  {
    title: 'Техническое сопровождение сайта',
    paragraphs: ['Постоянная работа команды специалистов.'],
  },
  {
    title: 'Информационно-техническая поддержка сайта',
    paragraphs: ['Консультации и помощь по всем вопросам.'],
  },
  {
    title: 'Актуализация сайта под требования РКН и законодательства',
    paragraphs: [
      'В рамках технического обслуживания сайта специалисты проводят аудит и приводят проект в соответствие с требованиями РКН. Юристами и разработчиками проверяется корректность обработки персональных данных, наличие обязательных документов и техническая реализация согласий пользователей.',
    ],
  },
];

const redesignScopeItems = [
  {
    title: 'Аудит текущего сайта',
    paragraphs: ['Анализ структуры и выявление проблем.'],
  },
  {
    title: 'Проектирование новой структуры',
    paragraphs: ['Разработка удобной логики страниц.'],
  },
  {
    title: 'UX/UI дизайн',
    paragraphs: ['Создание современного интерфейса.'],
  },
  {
    title: 'Обновление визуального стиля',
    paragraphs: ['Актуализация внешнего вида.'],
  },
  {
    title: 'Адаптивная верстка',
    paragraphs: ['Оптимизация под мобильные устройства.'],
  },
  {
    title: 'SEO при редизайне сайта',
    paragraphs: ['Сохранение и рост позиций.'],
  },
];

const technologies = [
  {
    title: 'WordPress (техническая поддержка сайта WordPress)',
    paragraphs: ['Поддержка и оптимизация сайтов.'],
  },
  {
    title: 'Bitrix (обслуживание сайтов на Битрикс)',
    paragraphs: ['Работа с корпоративными решениями.'],
  },
  {
    title: 'Самописные сайты',
    paragraphs: ['Поддержка индивидуальных разработок.'],
  },
  {
    title: 'Интеграции и API',
    paragraphs: ['Подключение CRM, платежей и сервисов.'],
  },
];

const processSteps = [
  {
    title: 'Аудит и диагностика сайта',
    paragraphs: ['Оценка текущего состояния.'],
  },
  {
    title: 'Настройка технической поддержки',
    paragraphs: ['Определение задач и процессов.'],
  },
  {
    title: 'Регулярное обслуживание сайта',
    paragraphs: ['Ежемесячное выполнение работ.'],
  },
  {
    title: 'Доработки и развитие',
    paragraphs: ['Внедрение новых функций.'],
  },
  {
    title: 'Масштабирование сайта',
    paragraphs: ['Рост проекта вместе с бизнесом.'],
  },
];

const approachItems = [
  {
    title: 'SLA и гарантии',
    paragraphs: ['Фиксированные сроки выполнения задач.'],
  },
  {
    title: 'Прозрачные процессы',
    paragraphs: ['Полная отчетность по работам.'],
  },
  {
    title: 'Быстрая техническая поддержка',
    paragraphs: ['Реакция от 15–30 минут.'],
  },
  {
    title: 'Фокус на стабильности и росте',
    paragraphs: ['Поддержка + развитие.'],
  },
  {
    title: 'SEO и развитие сайта',
    paragraphs: ['Рост позиций и трафика.'],
  },
];

const formats = [
  {
    title: 'Ежемесячное обслуживание сайта',
    paragraphs: ['Абонентская поддержка.'],
  },
  {
    title: 'Разовое техническое обслуживание',
    paragraphs: ['Решение конкретных задач.'],
  },
  {
    title: 'Почасовая поддержка сайта',
    paragraphs: ['Оплата за фактические часы.'],
  },
  {
    title: 'Полное сопровождение сайта',
    paragraphs: ['Комплексное ведение проекта.'],
  },
  {
    title: 'Обслуживание сайта под ключ',
    paragraphs: ['Передача всех задач команде.'],
  },
];

const benefits = [
  {
    title: 'Стабильно работающий сайт',
    paragraphs: ['Без сбоев и ошибок.'],
  },
  {
    title: 'Постоянную техническую поддержку',
    paragraphs: ['Быстрое решение задач.'],
  },
  {
    title: 'Обслуживание и развитие сайта',
    paragraphs: ['Рост и масштабирование.'],
  },
  {
    title: 'Улучшенный дизайн и UX',
    paragraphs: ['Повышение конверсии.'],
  },
  {
    title: 'Готовность к продвижению',
    paragraphs: ['Подготовка к SEO и рекламе.'],
  },
];

const supportTariffs = [
  ['Тариф', 'Часы', 'Поддержка', 'Мониторинг', 'Доработки', 'Цена'],
  ['Базовый', '10', '✔', '✔', '—', 'от 15 000 ₽'],
  ['Стандарт', '25', '✔', '✔', '✔', 'от 35 000 ₽'],
  ['Бизнес', '50', '✔', '✔', '✔', 'от 65 000 ₽'],
  ['Премиум', '100+', '✔', '✔', '✔', 'от 120 000 ₽'],
];

const redesignTariffs = [
  ['Тариф', 'Объем работ', 'UX/UI дизайн', 'Прототип', 'Адаптив', 'Цена'],
  ['Базовый', 'Лендинг / 1–3 страницы', '✔', '—', '✔', 'от 25 000 ₽'],
  ['Стандарт', 'Сайт до 10 страниц', '✔', '✔', '✔', 'от 60 000 ₽'],
  ['Бизнес', 'Корпоративный сайт', '✔', '✔', '✔', 'от 120 000 ₽'],
  ['Премиум', 'Интернет-магазин / сложный проект', '✔', '✔', '✔', 'от 200 000 ₽'],
];

const relatedServices = [
  {
    href: 'https://fatalitystudio.ru/services/websites/',
    title: 'Разработка сайтов под ключ',
  },
  {
    href: 'https://fatalitystudio.ru/services/seo/full-cycle/',
    title: 'SEO продвижение',
  },
  {
    href: 'https://fatalitystudio.ru/services/seo/technical/',
    title: 'Техническое SEO',
  },
  {
    href: 'https://fatalitystudio.ru/services/seo/audit/',
    title: 'Аудит сайта',
  },
];

const cases = [
  {
    title: 'Примеры сопровождения сайтов',
    text: 'Снижение количества ошибок и ускорение сайта в 2 раза.',
  },
  {
    title: 'Примеры реализации редизайна',
    text: 'Рост конверсии до 35% после обновления дизайна.',
  },
];

const reviews = [
  {
    name: 'Даниил К.',
    role: 'владелец кулинарной студии',
    text: 'Заказали обслуживание сайта и техническую поддержку. Сайт раньше часто падал, были ошибки. За первый месяц все исправили. Сейчас сайт работает стабильно, заявки идут ежедневно.',
  },
  {
    name: 'Екатерина М.',
    role: 'маркетолог ресторана',
    text: 'Делали сопровождение сайта и редизайн. Обновили структуру и дизайн. Конверсия выросла примерно на 40%. Поддержка отвечает быстро, задачи закрывают без задержек.',
  },
  {
    name: 'Осман О.',
    role: 'владелец интернет-магазина',
    text: 'Подключили обслуживание интернет сайта. Настроили резервное копирование, устранили ошибки. Сейчас сайт работает без сбоев, большая часть заказов идет из поиска.',
  },
];

const faqItems = [
  {
    question: 'Сколько стоит обслуживание сайта в месяц?',
    blocks: [
      'Стоимость зависит от объема задач и сложности проекта. Для небольших сайтов достаточно 10–15 часов в месяц. Для интернет-магазинов требуется от 25 часов. Цена рассчитывается индивидуально.',
    ],
  },
  {
    question: 'Что входит в обслуживание сайта?',
    blocks: [
      'Включает техническую поддержку, обновления, мониторинг, резервное копирование, исправление ошибок, доработки и работу с контентом.',
    ],
  },
  {
    question: 'Можно ли заказать редизайн сайта отдельно?',
    blocks: ['Да, редизайн можно заказать отдельно. Но лучше совмещать с поддержкой, чтобы сразу внедрить все улучшения.'],
  },
  {
    question: 'Какие сайты вы поддерживаете?',
    blocks: ['Работаем с WordPress, Bitrix, самописными сайтами, интернет-магазинами и корпоративными порталами.'],
  },
  {
    question: 'Есть ли техническая поддержка 24/7?',
    blocks: ['Да, при необходимости доступна круглосуточная поддержка сайта.'],
  },
];

const relatedCardTitleStyle = {
  color: 'var(--ink)',
  fontFamily: "'Space Grotesk', sans-serif",
  fontSize: '24px',
  fontWeight: 600,
  letterSpacing: '-0.025em',
  lineHeight: 1.16,
};

function Paragraphs({ paragraphs }) {
  return paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>);
}

function TextBlocks({ blocks }) {
  return (
    <>
      {blocks.map((block) => (
        <p key={block}>{block}</p>
      ))}
    </>
  );
}

function SectionHeader({ eyebrow, title, description, dark = false }) {
  return (
    <div className={`sec-head${dark ? ' ink-head' : ''}`}>
      <div>
        <div className={`eyebrow${dark ? ' cyan' : ''}`}>{eyebrow}</div>
        <h2>{title}</h2>
      </div>
      {description && <p className="sub">{description}</p>}
    </div>
  );
}

function Cards({ items, actionLabel }) {
  return (
    <div className="compact-card-grid">
      {items.map((item, index) => (
        <div className={`compact-card${actionLabel ? ' interactive-card' : ''}`} key={item.title}>
          <div className="compact-num">{String(index + 1).padStart(2, '0')}</div>
          <h3>{item.title}</h3>
          <Paragraphs paragraphs={item.paragraphs} />
          {actionLabel && (
            <SiteLink href="#redesign-support-lead" className="link-flat">
              {actionLabel}
            </SiteLink>
          )}
        </div>
      ))}
    </div>
  );
}

function ProcessRail({ items }) {
  return (
    <div className="process-rail process-rail-five">
      {items.map((item, index) => (
        <div className="process-step" key={item.title}>
          <div className="process-num">{String(index + 1).padStart(2, '0')}</div>
          <h3>{item.title}</h3>
          <Paragraphs paragraphs={item.paragraphs} />
        </div>
      ))}
    </div>
  );
}

function RedesignTimeline({ items }) {
  return (
    <ol className="redesign-stage-timeline" aria-label="Что входит в редизайн сайта">
      {items.map((item, index) => (
        <li className="redesign-stage-item" key={item.title}>
          <span className="redesign-stage-icon" aria-hidden="true">{String(index + 1).padStart(2, '0')}</span>
          <h3>{item.title}</h3>
          <Paragraphs paragraphs={item.paragraphs} />
        </li>
      ))}
    </ol>
  );
}

function PriceTable({ title, rows }) {
  return (
    <div>
      <h3 className="pricing-subhead">{title}</h3>
      <div className="price-table-scroll">
        <table className="redesign-support-tariff-table">
          <thead>
            <tr>
              {rows[0].map((cell) => <th scope="col" key={cell}>{cell}</th>)}
            </tr>
          </thead>
          <tbody>
            {rows.slice(1).map((row) => (
              <tr key={row.join('|')}>
                {row.map((cell, cellIndex) => (
                  cellIndex === 0
                    ? <th scope="row" key={cell}>{cell}</th>
                    : <td key={`${cellIndex}-${cell}`}>{cell}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function RedesignSupportPage() {
  const [openFaq, setOpenFaq] = useState(0);

  return (
    <RedesignPage>
      <PageMeta
        title="Обслуживание сайта и поддержка сайтов под ключ — техническая поддержка, редизайн"
        description="Закажите обслуживание сайта, поддержку, техническау поддержка сайта, редизайн. Мониторинг 24/7, исправление ошибок, обновление CMS, редизайн сайта и развитие, масштабирование проекта..Системный подход, множество кейсов и команда профессионалов.Ведем более 30 проектов на ежедневной тех.поддержке. Рассчитайте стоимость в веб-студии fatalitystudio.ru или по телефону +7 (925) 653-04-54 !"
      />
      <RedesignHeader />

      <section className="ink service-hero">
        <div
          className="glow"
          style={{ right: '-360px', top: '-340px', width: '980px', height: '980px', opacity: 0.1 }}
        />
        <div className="container service-hero-grid">
          <div>
            <div className="eyebrow cyan">— редизайн и поддержка</div>
            <h1>Обслуживание сайтов и редизайн сайта под ключ</h1>
            <div className="service-hero-copy">
              <Paragraphs paragraphs={heroParagraphs} />
            </div>
            <div className="hero-ctas">
              <SiteLink href="#redesign-support-lead" className="btn btn-primary">
                Обслуживание и редизайн сайта - в Fatality
              </SiteLink>
              <SiteLink href="#redesign-support-cases" className="btn btn-ghost-dark">
                примеры сопровождения сайтов
              </SiteLink>
            </div>
          </div>
          <div className="service-hero-panel" aria-label="Какие задачи решает обслуживание сайта">
            {tasks.map((item, index) => (
              <div className="panel-line" key={item.title}>
                <span>{String(index + 1).padStart(2, '0')}</span>
                <b>{item.title}</b>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader
            eyebrow="— бизнес"
            title="Обслуживание сайтов и техническая поддержка для бизнеса"
            description="Обслуживание сайтов и техническая поддержка — это основа стабильной работы любого интернет-проекта."
          />
          <div className="split-proof">
            <div>
              <Paragraphs paragraphs={supportBusinessParagraphs.slice(0, 1)} />
            </div>
            <div>
              <Paragraphs paragraphs={supportBusinessParagraphs.slice(1)} />
            </div>
          </div>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader
            eyebrow="— задачи"
            title="Какие задачи решает обслуживание сайта"
            description="Техническое обслуживание сайта закрывает сразу несколько ключевых задач бизнеса. Это не только поддержка, но и развитие проекта."
          />
          <Cards items={tasks} />
          <SiteLink href="#redesign-support-lead" className="btn btn-primary section-action">
            Обслуживание и редизайн сайта - в Fatality
          </SiteLink>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader
            eyebrow="— услуги"
            title="Какие услуги по обслуживанию сайтов мы предоставляем"
            description="Предоставляется полный спектр услуг по поддержке и сопровождению сайтов."
          />
          <Cards items={serviceItems} />
        </div>
      </section>

      <section className="ink sec-pad">
        <div className="container">
          <SectionHeader
            eyebrow="— редизайн"
            title="Редизайн сайта как часть обслуживания"
            description="Редизайн сайта — важный этап развития проекта. Он влияет на конверсию и пользовательский опыт."
            dark
          />
          <Cards items={redesignItems} actionLabel="Узнать стоимость" />
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader
            eyebrow="— поддержка"
            title="Что входит в обслуживание и поддержку сайта"
          />
          <Cards items={supportScopeItems} />
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader
            eyebrow="— редизайн"
            title="Что входит в редизайн сайта"
          />
          <RedesignTimeline items={redesignScopeItems} />
          <SiteLink href="#redesign-support-lead" className="btn btn-primary section-action">
            Начать проект
          </SiteLink>
        </div>
      </section>

      <section className="ink sec-pad">
        <div className="container">
          <SectionHeader eyebrow="— технологии" title="Технологии и платформы" dark />
          <div className="tech-tiles">
            {technologies.map((item, index) => (
              <div className="tech-tile" key={item.title}>
                <div className="why-n">{String(index + 1).padStart(2, '0')}</div>
                <h3>{item.title}</h3>
                <Paragraphs paragraphs={item.paragraphs} />
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader eyebrow="— процесс" title="Как проходит обслуживание сайта" />
          <ProcessRail items={processSteps} />
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader eyebrow="— подход" title="Подход к обслуживанию сайтов" />
          <Cards items={approachItems} />
        </div>
      </section>

      <section className="ink sec-pad">
        <div className="container">
          <SectionHeader eyebrow="— форматы" title="Форматы обслуживания сайтов" dark />
          <Cards items={formats} actionLabel="Выбрать этот формат" />
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader eyebrow="— итог" title="Что вы получаете" />
          <Cards items={benefits} />
          <SiteLink href="#redesign-support-lead" className="btn btn-primary section-action">
            Заказать обслуживание сайта
          </SiteLink>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader
            eyebrow="— стоимость"
            title="Стоимость обслуживания сайта"
            description="Цена зависит от сложности проекта и объема задач."
          />
          <div className="pricing-layout">
            <div className="price-list">
              <h3 className="pricing-subhead">Сколько стоит обслуживание сайта</h3>
              <p className="pricing-copy">Цена зависит от сложности проекта и объема задач.</p>
              <PriceTable title="Обслуживание сайта - тарифы" rows={supportTariffs} />
              <PriceTable title="Редизайн -  тарифы" rows={redesignTariffs} />
            </div>
            <div className="price-note">
              <h3>Получить расчет стоимости</h3>
              <p>Есть идея или проект? Оставьте заявку — рассчитаем стоимость и предложим решение.</p>
              {/* TODO(brand-redesign): add the manager trust block after the source photo and manager name are provided. */}
              <LeadForm
                formId="redesign-support-calc-form"
                idPrefix="redesign-support-calc"
                contactLabel="Телефон или E-mail"
                contactType="text"
                contactPlaceholder="+7 или почта"
                showTelegram={false}
                showCompany={false}
                typeLabel="Тип сайта"
                typeOptions={[
                  'Обслуживание сайта',
                  'Техническая поддержка сайта',
                  'Редизайн сайта',
                  'Обслуживание сайта под ключ',
                ]}
                submitLabel="Получить расчёт бесплатно"
                taskPlaceholder="Комментарий"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader eyebrow="— рядом" title="Похожие услуги" />
          <div className="related-grid">
            {relatedServices.map((item) => (
              <SiteLink href={item.href} className="related-card" key={item.title}>
                <div style={relatedCardTitleStyle}>{item.title}</div>
              </SiteLink>
            ))}
          </div>
        </div>
      </section>

      <section className="ink sec-pad" id="redesign-support-cases">
        <div className="container">
          <SectionHeader eyebrow="— кейсы" title="Кейсы обслуживания сайтов и редизайна" dark />
          <div className="case-teaser">
            <div className="case-blur-media">
              <div className="case-blur-tag">кейсы обслуживания сайтов и редизайна</div>
              <div className="case-blur-title">Рост конверсии до 35%</div>
            </div>
            <div className="case-teaser-body">
              {cases.map((item) => (
                <div key={item.title}>
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader eyebrow="— отзывы" title="Отзывы клиентов - реальные решения задач" />
          <ReviewsCarousel className="reviews-grid reviews-grid-three">
            {reviews.map((review) => (
              <figure className="review-card" aria-label={`${review.name}, ${review.role}`} key={review.name}>
                <blockquote>{review.text}</blockquote>
                <figcaption>
                  <b>{review.name}</b>
                  <span>{review.role}</span>
                </figcaption>
              </figure>
            ))}
          </ReviewsCarousel>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <div className="faq-grid">
            <div>
              <div className="eyebrow">— faq</div>
              <h2 className="standalone-h2">Ответы на частые вопросы</h2>
            </div>
            <div className="faq-list">
              {faqItems.map((item, index) => {
                const isOpen = openFaq === index;
                return (
                  <div className={`faq-item${isOpen ? ' open' : ''}`} key={item.question}>
                    <div className="faq-q">
                      <h3 className="faq-question-heading">
                        <button
                          aria-controls={`redesign-support-faq-answer-${index}`}
                          aria-expanded={isOpen}
                          className="faq-question-button"
                          type="button"
                          onClick={() => setOpenFaq(isOpen ? -1 : index)}
                        >
                          {item.question}
                        </button>
                      </h3>
                      <span className="faq-toggle" aria-hidden="true">+</span>
                    </div>
                    <div className="faq-a" id={`redesign-support-faq-answer-${index}`}>
                      <div className="faq-a-inner">
                        <TextBlocks blocks={item.blocks} />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      <section className="ink lead" id="redesign-support-lead">
        <div
          className="glow"
          style={{ left: '-300px', top: '-200px', width: '700px', height: '700px', opacity: 0.1 }}
        />
        <div className="container" style={{ position: 'relative' }}>
          <div className="lead-grid">
            <div className="lead-side">
              <div className="eyebrow cyan">— заявка</div>
              <h2 className="lead-heading">Заказать обслуживание сайта и редизайн</h2>
              <p className="lead-text">Напишите нам!</p>
              <p className="lead-text">
                P.S. Мы сами не любим холодные продажи и “впаривание услуг”, поэтому напишите в кратком описании, как Вам
                удобнее обсудить проект. 😀
              </p>
              <p className="lead-text">
                Специалисты свяжутся в удобном для Вас формате и предложат лучшее для Вас решение по цене, срокам и
                функционалу.
              </p>
            </div>
            <LeadForm
              formId="redesign-support-lead-form"
              idPrefix="redesign-support"
              contactLabel="Телефон или E-mail"
              contactType="text"
              contactPlaceholder="+7 или почта"
              showTelegram={false}
              showCompany={false}
              typeLabel="Тип сайта"
              typeOptions={[
                'Обслуживание сайта',
                'Техническая поддержка сайта',
                'Редизайн сайта',
                'Обслуживание сайта под ключ',
              ]}
              submitLabel="Получить расчёт бесплатно"
              taskPlaceholder="Напишите в кратком описании, как Вам удобнее обсудить проект"
            />
          </div>
        </div>
      </section>

      <RedesignFooter />
    </RedesignPage>
  );
}

export default RedesignSupportPage;
